import React from 'react';

import '../styles/Spinner.css';

const Spinner = () => (<div className="lds-hourglass"></div>);

export default Spinner;
